@if (loading===false){
<mat-drawer-container [hasBackdrop]="false">
  <mat-drawer-content>
    <div class="padded-side-nav">
      <div class="dashboard-section">
        <div id="chart">
          <div class="padded-side-nav">
            <div class="filter-holder">
              <div class="filter-buttons">
                <!-- <button
                  mat-raised-button
                  color="primary"
                  [class.active]="filterValue === twoMonthsAgo"
                  (click)="onFilterButtonClick(twoMonthsAgo)">
                  {{ twoMonthsAgo | date: 'yyyy-MM' }}
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [class.active]="filterValue === lastMonth"
                  (click)="onFilterButtonClick(lastMonth)">
                  {{ lastMonth | date: 'yyyy-MM' }}
                </button> -->
                <button
                  mat-raised-button
                  color="primary"
                  [class.active]="filterValue === today"
                  (click)="onFilterButtonClick(today)">
                  {{ today | date: 'yyyy-MM' }}
                </button>
              </div>
            </div>

            @if (projectRegionData.CustomerTypes && projectRegionData.CustomerTypes.length > 0) {
              <div class="filter-options project-region-filter">
                <mat-radio-group
                  aria-label="Select an option"
                  (change)="CustomerTypeChanged()"
                  [(ngModel)]="customerType"
                  [ngModelOptions]="{ standalone: true }"
                  [name]="'CheckCustomerType'">

                  <mat-radio-button class="checkbox-margins" value="">
                    All
                  </mat-radio-button>

                  @for (customer of projectRegionData.CustomerTypes; track customer) {
                    <mat-radio-button class="checkbox-margins" [value]="customer">
                      {{ customer }}
                    </mat-radio-button>
                  }

                </mat-radio-group>
              </div>
            }
            <br/>
            @if (projectRegionData.ProjectRegions && projectRegionData.ProjectRegions.length > 0) {
              <div class="filter-options project-region-filter">
                  <mat-radio-group
                  aria-label="Select an option"
                  (change)="ProjectRegionChanged()"
                  [(ngModel)]="projectRegionFilter"
                  [ngModelOptions]="{ standalone: true }"
                  [name]="'CheckProjectRegion'">

                  <mat-radio-button class="checkbox-margins" value="">
                      All
                  </mat-radio-button>

                    @for (region of projectRegionData.ProjectRegions; track region) {
                      <mat-radio-button class="checkbox-margins" [value]="region">
                        {{ region }}
                      </mat-radio-button>
                    }

                  </mat-radio-group>
              </div>
            }

            <div class="jobs-status-chart">
              <h5>Job Management Statistics:<br />{{startDate}} - {{endDate}} (Month to Day)</h5>
              <div class="dashboard-cards">
                <mat-card>
                  <h3>Jobs by JobType:</h3>
                  <p>Installation Jobs: {{ installationJobs ? installationJobs : 0 }}</p>
                  <p>Maintenance Jobs: {{ maintenanceJobs ? maintenanceJobs : 0 }}</p>
                  <p>Recovery Jobs: {{ recoveryJobs ? recoveryJobs : 0 }}</p>
                  <p>Total Jobs: {{ totalJobs ? totalJobs : 0 }}</p>

                </mat-card>
                <br/>
                <mat-card>
                  <h3>Average Kilometres:</h3>
                  <p>{{ averageKMs ? averageKMs.toFixed(2) : 0.00 }}</p>
                </mat-card>
                <br/>
                <mat-card>
                  <h3>Average Time:</h3>
                  <p>{{ averageTime ? averageTime : "00:00:00" }}</p>
                </mat-card>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="map-section">
          <div class="header-section"> </div>
          <!-- TODO Locations Need to be done and Calculate Center needs to be set to true -->
          <huge-monorepo-base-map
            [locations]="jobLocations ? jobLocations : null"
            [calculateCenter]="true"
            [showNetworkProviderLegend]="false"
            [showTowerLegend]="false"
            [updateActionButtons]="false"
            [fitBounds]="true"
          >
          </huge-monorepo-base-map>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
} @else {
<div class="loading">
  <mat-spinner diameter="50"></mat-spinner>
</div>
}
